import {Box} from '@mui/material';
import {useContext} from 'react';
import {Route, Switch, useRouteMatch, Redirect} from 'react-router-dom';
import {AuthContext} from '../../../../../contexts/auth/context';
import {AuthContextType} from '../../../../../contexts/auth/types';
import {ScreenPaths} from '../../../../../enums/screen-path';
import HomeMeOfficeScreen from '../home/home.me.screen';
import MyAffiliationsEntityMeOfficeScreen from '../my-affiliations/entity/my-affiliations.entity.me.screen';
import NotificationsMeOfficeScreen from '../notifications/notifications.me.screen';
import ProfileDetailsMeOfficeScreen from '../profile-details/profile-details.me.screen';
import ProfileMeOfficeScreen from '../profile/profile.me.screen';

export default function MeOffice() {
  // Routing
  let {path} = useRouteMatch();

  // Get context
  const authContext: AuthContextType = useContext(AuthContext);

  // Home screen available?
  const isHomeAvailable: boolean =
    !authContext.state.session?.systemAdministratorProfile &&
    !authContext.state.session?.partnerProfile &&
    (!authContext.state.session?.affiliations ||
      authContext.state.session?.affiliations.length === 0) &&
    (!authContext.state.session?.relationships ||
      authContext.state.session?.relationships.length === 0)
      ? true
      : false;

  return (
    <Box>
      <Switch>
        {/* Profile */}
        <Route exact path={`${path}${ScreenPaths.Me_Profile}`}>
          <ProfileMeOfficeScreen />
        </Route>

        {/* Profile details */}
        <Route exact path={`${path}${ScreenPaths.Me_ProfileDetails}`}>
          <ProfileDetailsMeOfficeScreen />
        </Route>

        {/* Notifications */}
        <Route exact path={`${path}${ScreenPaths.Me_Notifications}`}>
          <NotificationsMeOfficeScreen />
        </Route>
        {/* Home
                    Note: This screen should only be available if the user doesn't have at least one 
                    of these user types available: partner, system administrator, informal caregiver,
                    and professional caregiver. This will be the landing page in this situation.
                */}
        {isHomeAvailable && (
          <Route exact path={`${path}${ScreenPaths.Me_Home}`}>
            <HomeMeOfficeScreen />
          </Route>
        )}
        {/* My affiliations: entity profile */}
        {authContext.state.session?.affiliations &&
          Array.isArray(authContext.state.session.affiliations) &&
          authContext.state.session.affiliations.length > 0 && (
            <Route exact path={`${path}${ScreenPaths.Me_MyAffiliationsEntity}/:id`}>
              <MyAffiliationsEntityMeOfficeScreen />
            </Route>
          )}

        {/** Default route */}
        <Route path={path}>
          <Redirect to={isHomeAvailable ? `${path}${ScreenPaths.Me_Home}` : ScreenPaths.Office} />
        </Route>
      </Switch>
    </Box>
  );
}
